import {Heading, Text, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import DownloadApp from "./DownloadApp";

export default function JoinCampaign() {
  return ( 
  
  <FullScreenSection
        justifyContent="center"
        alignItems="center"
        isDarkBackground={false}
        backgroundColor="gray.800"
        py={32}
      >
        <VStack spacing={6} maxW="800px" textAlign="center">
          <Heading fontSize="3rem" fontWeight="bold" color="white">
            Join the Swiftchang Movement
          </Heading>
          <Text fontSize="1.3rem" color="white" lineHeight="1.8">
            Together, we're building a future where borders don't limit financial freedom. 
            Start your journey with Swiftchang today.
          </Text>
          <DownloadApp />
        </VStack>
      </FullScreenSection>
      
    );
}